import React, { useState } from 'react';
import { TextField, Button, Card, CardContent, Typography, Alert, Box } from '@mui/material';
import { signInWithEmailAndPassword, getAuth } from 'firebase/auth';
import { FirebaseConfig } from '../../data/firebaseConfig';

// Initialize Firebase
const app = FirebaseConfig.app;
const auth = getAuth(app);

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setError(null);
    setIsLoading(true);
    try {

      // Authenticate the user
      await signInWithEmailAndPassword(auth, email, password);

      // Extract tenant (email domain) from email
      // const emailDomain = email.split('@')[1];
      // if (!emailDomain) {
      //   throw new Error('Invalid email format');
      // }

      // // Fetch tenant configuration from Firestore
      // const tenantDoc = await getDoc(doc(db, 'tenants', emailDomain));
      // if (!tenantDoc.exists()) {
      //   throw new Error('Tenant not found');
      // }

      // const tenantData = tenantDoc.data();
      // if (!email.endsWith(`@${emailDomain}`)) {
      //   throw new Error('Email domain does not match tenant');
      // }

      // Redirect or handle successful login
      console.log('Login successful');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='backdrop'>
      <Card style={{ width: '100%', maxWidth: 400, boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
        {/* Banner with Logo */}
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.primary.contrastText,
            paddingTop: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          })}
        >
          <img src="/logo.png" alt="Logo" style={{ height: "40px" }} />
        </Box>
        <CardContent style={{ margin: '20px' }}>
          <Typography variant="h5" component="div" alignItems="center" gutterBottom>
            Login to Your Account
          </Typography>

          {error && <Alert severity="error" style={{ marginBottom: '15px' }}>{error}</Alert>}

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: '15px' }}
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </Button>
          <Button
            variant="text"
            color="primary"
            fullWidth
            style={{ marginTop: '10px' }}
            onClick={() => window.location.href = '/forgot-password'}
          >
            Forgot Password?
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
